// Windows Ready Handler
(function ($) {

    $(document).ready(function () {

        if (window.screen.availWidth < 1024) {
            $(".wp-block-navigation-item.has-child").children("ul").slideToggle();
        }


        $(".list-toggle").on("click", function (e) {
            let button = $(this);
            let icon = $(this).children("i");
            let list = $(this).siblings("ul");

            let isCurrentlyVisible = $(list).is(':visible');

            if (!isCurrentlyVisible) {
                icon.removeClass("fa-plus");
                icon.addClass("fa-minus");
                list.slideDown({
                    start: function () {
                        $(this).css({
                            display: "flex"
                        })
                    }
                });

            } else {
                icon.removeClass("fa-minus");
                icon.addClass("fa-plus");
                list.slideUp();
            }



        })


        if (window.screen.availWidth > 1023) {
            if ($(".current-category-item")) {
                let parents = $(".current-category-item").parents("ul").not(".wc-block-product-categories-list--depth-0");
                let parentButtons = $(".current-category-item").parents("li").children("button").children("i");

                console.log(parentButtons);
                parentButtons.each(function () {
                    $(this).removeClass("fa-plus").addClass("fa-minus");
                })


                console.log(parents);
                console.log(parents.length);
                parents.each(function () {
                    $(this).slideDown({
                        start: function () {
                            $(this).css({
                                display: "flex"
                            })
                        }
                    });
                })

            }
        }


        $(".wp-block-navigation-item.has-child").on("click", function (e) {
            e.stopPropagation();
            let item = $(this);
            let button = item.children("button");
            let list = item.children("ul");


            let isCurrentlyVisible = $(list).is(':visible');



            if (isCurrentlyVisible) {
                button.css('transform', 'rotate(0deg)');
            } else {
                button.css({
                    "transform": 'rotateX(180deg)'
                });

            }
            $(list).stop().slideToggle({
                duration: 500,
                start: function () {
                    $(this).css('display', 'flex');
                }
            });
        });

        if ($(".products-slider")) {
            let links = $(".products-slider").find("a");
            console.log(links);
            links.each(function () {
                let link = $(this);
                let slide = $(this).parents(".swiper-slide");
                console.log(slide);
                slide.on("click", () => {
                    this.click();
                })
            })
        }

        if ($(".brand-slider")) {
            let links = $(".brand-slider").find("a");
            console.log(links);
            links.each(function () {
                let link = $(this);
                let slide = $(this).parents(".swiper-slide");
                console.log(slide);
                slide.on("click", () => {
                    this.click();
                })
            })
        }

        if ($(".form-wppp-select.products-per-page")) {
            $('.form-wppp-select.products-per-page').appendTo('.results-group');
            let options = $('.form-wppp-select.products-per-page').find("option");
            // console.log( options );
            options.each(function () {
                let text = this.innerText.split(" ");
                this.innerText = text[0].trim();
            });

            // options.detach().sort((a, b) => {
            //     var aValue = parseInt($(a).val(), 10);
            //     var bValue = parseInt($(b).val(), 10);
            //     return aValue - bValue;
            // });
            // $('.fmewppp-select').append(options);

        }


        $("#popout-trigger").on('click', () => {
            $(".popout-form").toggleClass("open");
            // $("#gform_wrapper_1").slideDown();
        });

        $(".order-info").find("em").on('click', () => {
            $(".popout-form").toggleClass("open");
        });


        if ($("#wpadminbar")) {
            let adminbar = document.getElementById("wpadminbar");
            let header = document.querySelector(".site-header");

            if (adminbar?.style?.display === 'none') {
                header.style.top = "0px";
            }

            const observer = new MutationObserver(mutationsList => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes' && adminbar.style.display === 'none') {
                        header.style.top = '0px'; // change this to the desired top value
                    } else {
                        header.style.top = '32px'; // change this to the original top value
                    }
                }
            });
            if (adminbar) {
                observer.observe(adminbar, { attributes: true, attributeFilter: ['style'] });

            }

        }

        $(document.body).on('updated_cart_totals', function() {
            window.location.reload();
        });

        // if ($(".wc-update-cart-submit-button")) {
        //     let button = $(".wc-update-cart-submit-button");
        //     console.log(button);
        //     let form = $(button).closest("form");
        //     console.log(form);
        //     form.on('submit', function (event) {
        //         // Prevent the default form submission
        //         event.preventDefault();

        //         // Serialize the form data
        //         var formData = $(this).serialize();

        //         console.log("Should reload");
        //         // Send the AJAX request to update the cart
        //         $.ajax({
        //             type: 'POST',
        //             url: wc_cart_params.ajax_url,
        //             data: formData,
        //             success: function (response) {
        //                 // If the cart is updated successfully, reload the page
        //                 if (!response.error) {
        //                     window.location.reload();
        //                 }
        //             }
        //         });
        //     })
        // }

    });

}(jQuery));
